import React, { useMemo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Paper, Typography, Box } from '@material-ui/core';
import { PieChart, Pie, Sector, Cell } from 'recharts';
import { COLORS } from '../../constants/colors';
import { useDashboardStyles } from '../../styles/DashboardInformeStyle';


const renderActiveShape = (props) => {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;

  return (
    <g>
      <text x={cx} y={cy - 18} textAnchor="middle" fill={fill} fontWeight="bold" fontSize={12}>
        {payload.name}
      </text>
      <text x={cx} y={cy + 2} textAnchor="middle" fill="#333" fontSize={14} fontWeight="bold">
        {`${value} ${value === 1 ? 'registro' : 'registros'}`}
      </text>
      <text x={cx} y={cy + 20} textAnchor="middle" fill="#999" fontSize={11}>
        {`(${(percent * 100).toFixed(1)}%)`}
      </text>
      <Sector
        cx={cx} cy={cy}
        innerRadius={innerRadius} outerRadius={outerRadius}
        startAngle={startAngle} endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx} cy={cy}
        startAngle={startAngle} endAngle={endAngle}
        innerRadius={outerRadius + 6} outerRadius={outerRadius + 10}
        fill={fill}
      />
    </g>
  );
};

export default function DonutChart({ series, labels }) {
  const classes = useDashboardStyles();
  const [activeIndex, setActiveIndex] = useState(0);

  const data = labels.map((name, i) => ({ name, value: series[i] || 0 }));

  const onPieEnter = useCallback((_, index) => {
    setActiveIndex(index);
  }, []);

  if (!series.length) {
    return (
      <Paper className={classes.chartCard}>
        <Typography className={classes.chartTitle} color="primary">
          Registros pendientes
        </Typography>
        <Typography style={{ color: '#aaa', textAlign: 'center', marginTop: 40 }}>
          Sin registros pendientes
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper className={classes.chartCard}>
      <Typography className={classes.chartTitle} color="primary">
        Registros pendientes
      </Typography>
      <Box style={{ display: 'flex', justifyContent: 'center' }}>
        <PieChart width={320} height={280}>
          <Pie
            activeIndex={activeIndex}
            activeShape={renderActiveShape}
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={70}
            outerRadius={100}
            dataKey="value"
            onMouseEnter={onPieEnter}
          >
            {data.map((_, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS.donut[index % COLORS.donut.length]}
              />
            ))}
          </Pie>
        </PieChart>
      </Box>
    </Paper>
  );
}

DonutChart.propTypes = {
  series: PropTypes.arrayOf(PropTypes.number).isRequired,
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

